import React, { PropTypes } from 'react';
import { Link, IndexLink, browserHistory } from 'react-router';
import { REQUEST_STATUS } from '../../../constants/general';

import './UserHomePage.scss';
import RequestSummary from '../../../components/RequestSummary/RequestSummary';

class UserHomePage extends React.Component {
    constructor(props) {
        super(props);
        // this.chooseUser = this.chooseUser.bind(this);
    }

    render() {
        const {requests, routes} = this.props;

        const renderActiveRequests = requests
            .sort((a, b) => {
                return b.requestInfo.requestDate - a.requestInfo.requestDate;
            })
            .map((request, i) => {
                if (!(request.requestInfo.requestStatus === REQUEST_STATUS.delivered ||
                    request.requestInfo.requestStatus === REQUEST_STATUS.denied)) {
                    return (
                        <RequestSummary {...request} routes={routes} key={i}/>
                    );
                }
            });

        return (
            <div className="user-home-page">
                <h1>User Dashboard</h1>
                <hr />
                <div className="header"><h3>Active Requests</h3></div>
                {renderActiveRequests}
                <hr />
            </div>
        );
    }
}

export default UserHomePage;



/** WEBPACK FOOTER **
 ** ./src/components/User/UserHomePage/UserHomePage.js
 **/